import '../css/style.css';

const h1El = document.body.querySelector('h1');

h1El.textContent = 'Webpack';